<template>
  <div class="ui-update-bar">
      {{ $t('update_bar.text') }}
      <button class="reload-button" @click="doReload">
          {{ $t('update_bar.button') }}
      </button>
  </div>
</template>

<script>
export default {
    methods: {
        doReload() {
            window.location.reload();
        }
    }
}
</script>

<style scoped>
.ui-update-bar {
    background-color: #1d1d1b;
    color: #ededed;
    font-size: 2.1vh;
    text-align: center;

    width: 72vw;

    position: fixed;
    margin: auto;

    display: flex;
    align-items: center;
    justify-content: space-between;

    top: 6vh;

    left: 32vh;
    right: 0;
    z-index: 4242;
    border-radius: 1vh;
    padding: 1vh 1vh;

    animation: fadein 0.5s;
    transition: 0.4s;

    cursor: pointer;
}

.reload-button {
    outline: none;
    background: #FFD2A8;
    border-radius: 0.5vh;
    color: #1d1d1b;
    border: 0;
    text-align: center;
    cursor: pointer;
    padding: 0.5vh 0.5vh;
}
</style>